// source: dash.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var proto = {};

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
goog.exportSymbol('dash.AlertMessage', null, proto);
goog.exportSymbol('dash.AppMessage', null, proto);
goog.exportSymbol('dash.CommandMessage', null, proto);
goog.exportSymbol('dash.CommandType', null, proto);
goog.exportSymbol('dash.DataMessage', null, proto);
goog.exportSymbol('dash.DebugCommand', null, proto);
goog.exportSymbol('dash.DebugTimeOutMessage', null, proto);
goog.exportSymbol('dash.DeleteCommand', null, proto);
goog.exportSymbol('dash.EventMessage', null, proto);
goog.exportSymbol('dash.EventType', null, proto);
goog.exportSymbol('dash.GetEventsMessage', null, proto);
goog.exportSymbol('dash.GetPayloadCommand', null, proto);
goog.exportSymbol('dash.InitMessage', null, proto);
goog.exportSymbol('dash.ListLogCommand', null, proto);
goog.exportSymbol('dash.LogResponseMessage', null, proto);
goog.exportSymbol('dash.MessageRef', null, proto);
goog.exportSymbol('dash.MessageStep', null, proto);
goog.exportSymbol('dash.MessageType', null, proto);
goog.exportSymbol('dash.OTACommand', null, proto);
goog.exportSymbol('dash.OTAResponseMessage', null, proto);
goog.exportSymbol('dash.PauseQueueCommand', null, proto);
goog.exportSymbol('dash.PlayCommand', null, proto);
goog.exportSymbol('dash.QueueContentMessage', null, proto);
goog.exportSymbol('dash.QueueItemCommand', null, proto);
goog.exportSymbol('dash.QueueItemMessage', null, proto);
goog.exportSymbol('dash.QueuesMessage', null, proto);
goog.exportSymbol('dash.ReadLogCommand', null, proto);
goog.exportSymbol('dash.ReplaceQueuePayloadCommand', null, proto);
goog.exportSymbol('dash.ResponseMessage', null, proto);
goog.exportSymbol('dash.ResumeQueueCommand', null, proto);
goog.exportSymbol('dash.SearchCommand', null, proto);
goog.exportSymbol('dash.SearchContentMessage', null, proto);
goog.exportSymbol('dash.SetConfigCommand', null, proto);
goog.exportSymbol('dash.Stage', null, proto);
goog.exportSymbol('dash.StartDataStreamCommand', null, proto);
goog.exportSymbol('dash.StatsMessage', null, proto);
goog.exportSymbol('dash.StepMessage', null, proto);
goog.exportSymbol('dash.StopCommand', null, proto);
goog.exportSymbol('dash.StopDataStreamCommand', null, proto);
goog.exportSymbol('dash.Strings', null, proto);
goog.exportSymbol('dash.UIVersionMessage', null, proto);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.AppMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.AppMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.AppMessage.displayName = 'proto.dash.AppMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.CommandMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.CommandMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.CommandMessage.displayName = 'proto.dash.CommandMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.QueuesMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.QueuesMessage.repeatedFields_, null);
};
goog.inherits(proto.dash.QueuesMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.QueuesMessage.displayName = 'proto.dash.QueuesMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.QueueItemMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.QueueItemMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.QueueItemMessage.displayName = 'proto.dash.QueueItemMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.QueueContentMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.QueueContentMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.QueueContentMessage.displayName = 'proto.dash.QueueContentMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.SearchContentMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.SearchContentMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.SearchContentMessage.displayName = 'proto.dash.SearchContentMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.LogResponseMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.LogResponseMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.LogResponseMessage.displayName = 'proto.dash.LogResponseMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.DataMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.DataMessage.repeatedFields_, null);
};
goog.inherits(proto.dash.DataMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.DataMessage.displayName = 'proto.dash.DataMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.AlertMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.AlertMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.AlertMessage.displayName = 'proto.dash.AlertMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.UIVersionMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.UIVersionMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.UIVersionMessage.displayName = 'proto.dash.UIVersionMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.ResponseMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.ResponseMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.ResponseMessage.displayName = 'proto.dash.ResponseMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.StatsMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.StatsMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.StatsMessage.displayName = 'proto.dash.StatsMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.DebugTimeOutMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.DebugTimeOutMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.DebugTimeOutMessage.displayName = 'proto.dash.DebugTimeOutMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.StepMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.StepMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.StepMessage.displayName = 'proto.dash.StepMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.MessageStep = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.MessageStep, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.MessageStep.displayName = 'proto.dash.MessageStep';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.GetEventsMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.GetEventsMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.GetEventsMessage.displayName = 'proto.dash.GetEventsMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.MessageRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.MessageRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.MessageRef.displayName = 'proto.dash.MessageRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.InitMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.InitMessage.repeatedFields_, null);
};
goog.inherits(proto.dash.InitMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.InitMessage.displayName = 'proto.dash.InitMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.DebugCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.DebugCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.DebugCommand.displayName = 'proto.dash.DebugCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.StopCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.StopCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.StopCommand.displayName = 'proto.dash.StopCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.QueueItemCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.QueueItemCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.QueueItemCommand.displayName = 'proto.dash.QueueItemCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.PauseQueueCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.PauseQueueCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.PauseQueueCommand.displayName = 'proto.dash.PauseQueueCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.DeleteCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.DeleteCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.DeleteCommand.displayName = 'proto.dash.DeleteCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.ReplaceQueuePayloadCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.ReplaceQueuePayloadCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.ReplaceQueuePayloadCommand.displayName = 'proto.dash.ReplaceQueuePayloadCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.ResumeQueueCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.ResumeQueueCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.ResumeQueueCommand.displayName = 'proto.dash.ResumeQueueCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.SearchCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.SearchCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.SearchCommand.displayName = 'proto.dash.SearchCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.ListLogCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.ListLogCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.ListLogCommand.displayName = 'proto.dash.ListLogCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.ReadLogCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.ReadLogCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.ReadLogCommand.displayName = 'proto.dash.ReadLogCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.OTACommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.OTACommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.OTACommand.displayName = 'proto.dash.OTACommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.GetPayloadCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.GetPayloadCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.GetPayloadCommand.displayName = 'proto.dash.GetPayloadCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.SetConfigCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.SetConfigCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.SetConfigCommand.displayName = 'proto.dash.SetConfigCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.StartDataStreamCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.StartDataStreamCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.StartDataStreamCommand.displayName = 'proto.dash.StartDataStreamCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.StopDataStreamCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.StopDataStreamCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.StopDataStreamCommand.displayName = 'proto.dash.StopDataStreamCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.PlayCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.PlayCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.PlayCommand.displayName = 'proto.dash.PlayCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.Strings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.dash.Strings.repeatedFields_, null);
};
goog.inherits(proto.dash.Strings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.Strings.displayName = 'proto.dash.Strings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.EventMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.EventMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.EventMessage.displayName = 'proto.dash.EventMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dash.OTAResponseMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dash.OTAResponseMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dash.OTAResponseMessage.displayName = 'proto.dash.OTAResponseMessage';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.AppMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.AppMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.AppMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.AppMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagetype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionhash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    init: (f = msg.getInit()) && proto.dash.InitMessage.toObject(includeInstance, f),
    appversion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    queues: (f = msg.getQueues()) && proto.dash.QueuesMessage.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && proto.dash.EventMessage.toObject(includeInstance, f),
    queuecontent: (f = msg.getQueuecontent()) && proto.dash.QueueContentMessage.toObject(includeInstance, f),
    response: (f = msg.getResponse()) && proto.dash.ResponseMessage.toObject(includeInstance, f),
    search: (f = msg.getSearch()) && proto.dash.SearchContentMessage.toObject(includeInstance, f),
    otaresponse: (f = msg.getOtaresponse()) && proto.dash.OTAResponseMessage.toObject(includeInstance, f),
    logresponse: (f = msg.getLogresponse()) && proto.dash.LogResponseMessage.toObject(includeInstance, f),
    browsermessage: msg.getBrowsermessage_asB64(),
    senddata: (f = msg.getSenddata()) && proto.dash.DataMessage.toObject(includeInstance, f),
    statsmessage: (f = msg.getStatsmessage()) && proto.dash.StatsMessage.toObject(includeInstance, f),
    debugtimeoutmessage: (f = msg.getDebugtimeoutmessage()) && proto.dash.DebugTimeOutMessage.toObject(includeInstance, f),
    listevents: (f = msg.getListevents()) && proto.dash.GetEventsMessage.toObject(includeInstance, f),
    sendalert: (f = msg.getSendalert()) && proto.dash.AlertMessage.toObject(includeInstance, f),
    version: (f = msg.getVersion()) && proto.dash.UIVersionMessage.toObject(includeInstance, f),
    sendstep: (f = msg.getSendstep()) && proto.dash.MessageStep.toObject(includeInstance, f),
    sendref: (f = msg.getSendref()) && proto.dash.MessageRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.AppMessage}
 */
proto.dash.AppMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.AppMessage;
  return proto.dash.AppMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.AppMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.AppMessage}
 */
proto.dash.AppMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.dash.MessageType} */ (reader.readEnum());
      msg.setMessagetype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionhash(value);
      break;
    case 3:
      var value = new proto.dash.InitMessage;
      reader.readMessage(value,proto.dash.InitMessage.deserializeBinaryFromReader);
      msg.setInit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversion(value);
      break;
    case 5:
      var value = new proto.dash.QueuesMessage;
      reader.readMessage(value,proto.dash.QueuesMessage.deserializeBinaryFromReader);
      msg.setQueues(value);
      break;
    case 6:
      var value = new proto.dash.EventMessage;
      reader.readMessage(value,proto.dash.EventMessage.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 7:
      var value = new proto.dash.QueueContentMessage;
      reader.readMessage(value,proto.dash.QueueContentMessage.deserializeBinaryFromReader);
      msg.setQueuecontent(value);
      break;
    case 8:
      var value = new proto.dash.ResponseMessage;
      reader.readMessage(value,proto.dash.ResponseMessage.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 9:
      var value = new proto.dash.SearchContentMessage;
      reader.readMessage(value,proto.dash.SearchContentMessage.deserializeBinaryFromReader);
      msg.setSearch(value);
      break;
    case 10:
      var value = new proto.dash.OTAResponseMessage;
      reader.readMessage(value,proto.dash.OTAResponseMessage.deserializeBinaryFromReader);
      msg.setOtaresponse(value);
      break;
    case 11:
      var value = new proto.dash.LogResponseMessage;
      reader.readMessage(value,proto.dash.LogResponseMessage.deserializeBinaryFromReader);
      msg.setLogresponse(value);
      break;
    case 12:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBrowsermessage(value);
      break;
    case 13:
      var value = new proto.dash.DataMessage;
      reader.readMessage(value,proto.dash.DataMessage.deserializeBinaryFromReader);
      msg.setSenddata(value);
      break;
    case 14:
      var value = new proto.dash.StatsMessage;
      reader.readMessage(value,proto.dash.StatsMessage.deserializeBinaryFromReader);
      msg.setStatsmessage(value);
      break;
    case 15:
      var value = new proto.dash.DebugTimeOutMessage;
      reader.readMessage(value,proto.dash.DebugTimeOutMessage.deserializeBinaryFromReader);
      msg.setDebugtimeoutmessage(value);
      break;
    case 16:
      var value = new proto.dash.GetEventsMessage;
      reader.readMessage(value,proto.dash.GetEventsMessage.deserializeBinaryFromReader);
      msg.setListevents(value);
      break;
    case 17:
      var value = new proto.dash.AlertMessage;
      reader.readMessage(value,proto.dash.AlertMessage.deserializeBinaryFromReader);
      msg.setSendalert(value);
      break;
    case 18:
      var value = new proto.dash.UIVersionMessage;
      reader.readMessage(value,proto.dash.UIVersionMessage.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 19:
      var value = new proto.dash.MessageStep;
      reader.readMessage(value,proto.dash.MessageStep.deserializeBinaryFromReader);
      msg.setSendstep(value);
      break;
    case 20:
      var value = new proto.dash.MessageRef;
      reader.readMessage(value,proto.dash.MessageRef.deserializeBinaryFromReader);
      msg.setSendref(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.AppMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.AppMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.AppMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.AppMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagetype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionhash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInit();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.dash.InitMessage.serializeBinaryToWriter
    );
  }
  f = message.getAppversion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQueues();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.dash.QueuesMessage.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.dash.EventMessage.serializeBinaryToWriter
    );
  }
  f = message.getQueuecontent();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.dash.QueueContentMessage.serializeBinaryToWriter
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.dash.ResponseMessage.serializeBinaryToWriter
    );
  }
  f = message.getSearch();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.dash.SearchContentMessage.serializeBinaryToWriter
    );
  }
  f = message.getOtaresponse();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.dash.OTAResponseMessage.serializeBinaryToWriter
    );
  }
  f = message.getLogresponse();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.dash.LogResponseMessage.serializeBinaryToWriter
    );
  }
  f = message.getBrowsermessage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      12,
      f
    );
  }
  f = message.getSenddata();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.dash.DataMessage.serializeBinaryToWriter
    );
  }
  f = message.getStatsmessage();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.dash.StatsMessage.serializeBinaryToWriter
    );
  }
  f = message.getDebugtimeoutmessage();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.dash.DebugTimeOutMessage.serializeBinaryToWriter
    );
  }
  f = message.getListevents();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.dash.GetEventsMessage.serializeBinaryToWriter
    );
  }
  f = message.getSendalert();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.dash.AlertMessage.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.dash.UIVersionMessage.serializeBinaryToWriter
    );
  }
  f = message.getSendstep();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.dash.MessageStep.serializeBinaryToWriter
    );
  }
  f = message.getSendref();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.dash.MessageRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional MessageType MessageType = 1;
 * @return {!proto.dash.MessageType}
 */
proto.dash.AppMessage.prototype.getMessagetype = function() {
  return /** @type {!proto.dash.MessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.dash.MessageType} value
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.setMessagetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string SessionHash = 2;
 * @return {string}
 */
proto.dash.AppMessage.prototype.getSessionhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.setSessionhash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional InitMessage Init = 3;
 * @return {?proto.dash.InitMessage}
 */
proto.dash.AppMessage.prototype.getInit = function() {
  return /** @type{?proto.dash.InitMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.InitMessage, 3));
};


/**
 * @param {?proto.dash.InitMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setInit = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearInit = function() {
  return this.setInit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasInit = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string AppVersion = 4;
 * @return {string}
 */
proto.dash.AppMessage.prototype.getAppversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.setAppversion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional QueuesMessage Queues = 5;
 * @return {?proto.dash.QueuesMessage}
 */
proto.dash.AppMessage.prototype.getQueues = function() {
  return /** @type{?proto.dash.QueuesMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.QueuesMessage, 5));
};


/**
 * @param {?proto.dash.QueuesMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setQueues = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearQueues = function() {
  return this.setQueues(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasQueues = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EventMessage Event = 6;
 * @return {?proto.dash.EventMessage}
 */
proto.dash.AppMessage.prototype.getEvent = function() {
  return /** @type{?proto.dash.EventMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.EventMessage, 6));
};


/**
 * @param {?proto.dash.EventMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional QueueContentMessage QueueContent = 7;
 * @return {?proto.dash.QueueContentMessage}
 */
proto.dash.AppMessage.prototype.getQueuecontent = function() {
  return /** @type{?proto.dash.QueueContentMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.QueueContentMessage, 7));
};


/**
 * @param {?proto.dash.QueueContentMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setQueuecontent = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearQueuecontent = function() {
  return this.setQueuecontent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasQueuecontent = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ResponseMessage Response = 8;
 * @return {?proto.dash.ResponseMessage}
 */
proto.dash.AppMessage.prototype.getResponse = function() {
  return /** @type{?proto.dash.ResponseMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.ResponseMessage, 8));
};


/**
 * @param {?proto.dash.ResponseMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional SearchContentMessage Search = 9;
 * @return {?proto.dash.SearchContentMessage}
 */
proto.dash.AppMessage.prototype.getSearch = function() {
  return /** @type{?proto.dash.SearchContentMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.SearchContentMessage, 9));
};


/**
 * @param {?proto.dash.SearchContentMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setSearch = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearSearch = function() {
  return this.setSearch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasSearch = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional OTAResponseMessage OTAResponse = 10;
 * @return {?proto.dash.OTAResponseMessage}
 */
proto.dash.AppMessage.prototype.getOtaresponse = function() {
  return /** @type{?proto.dash.OTAResponseMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.OTAResponseMessage, 10));
};


/**
 * @param {?proto.dash.OTAResponseMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setOtaresponse = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearOtaresponse = function() {
  return this.setOtaresponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasOtaresponse = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional LogResponseMessage LogResponse = 11;
 * @return {?proto.dash.LogResponseMessage}
 */
proto.dash.AppMessage.prototype.getLogresponse = function() {
  return /** @type{?proto.dash.LogResponseMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.LogResponseMessage, 11));
};


/**
 * @param {?proto.dash.LogResponseMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setLogresponse = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearLogresponse = function() {
  return this.setLogresponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasLogresponse = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bytes BrowserMessage = 12;
 * @return {!(string|Uint8Array)}
 */
proto.dash.AppMessage.prototype.getBrowsermessage = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * optional bytes BrowserMessage = 12;
 * This is a type-conversion wrapper around `getBrowsermessage()`
 * @return {string}
 */
proto.dash.AppMessage.prototype.getBrowsermessage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBrowsermessage()));
};


/**
 * optional bytes BrowserMessage = 12;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBrowsermessage()`
 * @return {!Uint8Array}
 */
proto.dash.AppMessage.prototype.getBrowsermessage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBrowsermessage()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.setBrowsermessage = function(value) {
  return jspb.Message.setProto3BytesField(this, 12, value);
};


/**
 * optional DataMessage SendData = 13;
 * @return {?proto.dash.DataMessage}
 */
proto.dash.AppMessage.prototype.getSenddata = function() {
  return /** @type{?proto.dash.DataMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.DataMessage, 13));
};


/**
 * @param {?proto.dash.DataMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setSenddata = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearSenddata = function() {
  return this.setSenddata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasSenddata = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional StatsMessage StatsMessage = 14;
 * @return {?proto.dash.StatsMessage}
 */
proto.dash.AppMessage.prototype.getStatsmessage = function() {
  return /** @type{?proto.dash.StatsMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.StatsMessage, 14));
};


/**
 * @param {?proto.dash.StatsMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setStatsmessage = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearStatsmessage = function() {
  return this.setStatsmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasStatsmessage = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional DebugTimeOutMessage DebugTimeOutMessage = 15;
 * @return {?proto.dash.DebugTimeOutMessage}
 */
proto.dash.AppMessage.prototype.getDebugtimeoutmessage = function() {
  return /** @type{?proto.dash.DebugTimeOutMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.DebugTimeOutMessage, 15));
};


/**
 * @param {?proto.dash.DebugTimeOutMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setDebugtimeoutmessage = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearDebugtimeoutmessage = function() {
  return this.setDebugtimeoutmessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasDebugtimeoutmessage = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional GetEventsMessage ListEvents = 16;
 * @return {?proto.dash.GetEventsMessage}
 */
proto.dash.AppMessage.prototype.getListevents = function() {
  return /** @type{?proto.dash.GetEventsMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.GetEventsMessage, 16));
};


/**
 * @param {?proto.dash.GetEventsMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setListevents = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearListevents = function() {
  return this.setListevents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasListevents = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional AlertMessage SendAlert = 17;
 * @return {?proto.dash.AlertMessage}
 */
proto.dash.AppMessage.prototype.getSendalert = function() {
  return /** @type{?proto.dash.AlertMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.AlertMessage, 17));
};


/**
 * @param {?proto.dash.AlertMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setSendalert = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearSendalert = function() {
  return this.setSendalert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasSendalert = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional UIVersionMessage Version = 18;
 * @return {?proto.dash.UIVersionMessage}
 */
proto.dash.AppMessage.prototype.getVersion = function() {
  return /** @type{?proto.dash.UIVersionMessage} */ (
    jspb.Message.getWrapperField(this, proto.dash.UIVersionMessage, 18));
};


/**
 * @param {?proto.dash.UIVersionMessage|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional MessageStep SendStep = 19;
 * @return {?proto.dash.MessageStep}
 */
proto.dash.AppMessage.prototype.getSendstep = function() {
  return /** @type{?proto.dash.MessageStep} */ (
    jspb.Message.getWrapperField(this, proto.dash.MessageStep, 19));
};


/**
 * @param {?proto.dash.MessageStep|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setSendstep = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearSendstep = function() {
  return this.setSendstep(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasSendstep = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional MessageRef SendRef = 20;
 * @return {?proto.dash.MessageRef}
 */
proto.dash.AppMessage.prototype.getSendref = function() {
  return /** @type{?proto.dash.MessageRef} */ (
    jspb.Message.getWrapperField(this, proto.dash.MessageRef, 20));
};


/**
 * @param {?proto.dash.MessageRef|undefined} value
 * @return {!proto.dash.AppMessage} returns this
*/
proto.dash.AppMessage.prototype.setSendref = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.AppMessage} returns this
 */
proto.dash.AppMessage.prototype.clearSendref = function() {
  return this.setSendref(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.AppMessage.prototype.hasSendref = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.CommandMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.CommandMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.CommandMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.CommandMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    commandtype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    debug: (f = msg.getDebug()) && proto.dash.DebugCommand.toObject(includeInstance, f),
    stop: (f = msg.getStop()) && proto.dash.StopCommand.toObject(includeInstance, f),
    queueitem: (f = msg.getQueueitem()) && proto.dash.QueueItemCommand.toObject(includeInstance, f),
    pausequeue: (f = msg.getPausequeue()) && proto.dash.PauseQueueCommand.toObject(includeInstance, f),
    resumequeue: (f = msg.getResumequeue()) && proto.dash.ResumeQueueCommand.toObject(includeInstance, f),
    search: (f = msg.getSearch()) && proto.dash.SearchCommand.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && proto.dash.GetPayloadCommand.toObject(includeInstance, f),
    ota: (f = msg.getOta()) && proto.dash.OTACommand.toObject(includeInstance, f),
    listlogs: (f = msg.getListlogs()) && proto.dash.ListLogCommand.toObject(includeInstance, f),
    readlog: (f = msg.getReadlog()) && proto.dash.ReadLogCommand.toObject(includeInstance, f),
    replacequeuepayload: (f = msg.getReplacequeuepayload()) && proto.dash.ReplaceQueuePayloadCommand.toObject(includeInstance, f),
    setconfig: (f = msg.getSetconfig()) && proto.dash.SetConfigCommand.toObject(includeInstance, f),
    pb_delete: (f = msg.getDelete()) && proto.dash.DeleteCommand.toObject(includeInstance, f),
    startdata: (f = msg.getStartdata()) && proto.dash.StartDataStreamCommand.toObject(includeInstance, f),
    stopdata: (f = msg.getStopdata()) && proto.dash.StopDataStreamCommand.toObject(includeInstance, f),
    play: (f = msg.getPlay()) && proto.dash.PlayCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.CommandMessage}
 */
proto.dash.CommandMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.CommandMessage;
  return proto.dash.CommandMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.CommandMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.CommandMessage}
 */
proto.dash.CommandMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.dash.CommandType} */ (reader.readEnum());
      msg.setCommandtype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = new proto.dash.DebugCommand;
      reader.readMessage(value,proto.dash.DebugCommand.deserializeBinaryFromReader);
      msg.setDebug(value);
      break;
    case 4:
      var value = new proto.dash.StopCommand;
      reader.readMessage(value,proto.dash.StopCommand.deserializeBinaryFromReader);
      msg.setStop(value);
      break;
    case 5:
      var value = new proto.dash.QueueItemCommand;
      reader.readMessage(value,proto.dash.QueueItemCommand.deserializeBinaryFromReader);
      msg.setQueueitem(value);
      break;
    case 6:
      var value = new proto.dash.PauseQueueCommand;
      reader.readMessage(value,proto.dash.PauseQueueCommand.deserializeBinaryFromReader);
      msg.setPausequeue(value);
      break;
    case 7:
      var value = new proto.dash.ResumeQueueCommand;
      reader.readMessage(value,proto.dash.ResumeQueueCommand.deserializeBinaryFromReader);
      msg.setResumequeue(value);
      break;
    case 8:
      var value = new proto.dash.SearchCommand;
      reader.readMessage(value,proto.dash.SearchCommand.deserializeBinaryFromReader);
      msg.setSearch(value);
      break;
    case 9:
      var value = new proto.dash.GetPayloadCommand;
      reader.readMessage(value,proto.dash.GetPayloadCommand.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 10:
      var value = new proto.dash.OTACommand;
      reader.readMessage(value,proto.dash.OTACommand.deserializeBinaryFromReader);
      msg.setOta(value);
      break;
    case 11:
      var value = new proto.dash.ListLogCommand;
      reader.readMessage(value,proto.dash.ListLogCommand.deserializeBinaryFromReader);
      msg.setListlogs(value);
      break;
    case 12:
      var value = new proto.dash.ReadLogCommand;
      reader.readMessage(value,proto.dash.ReadLogCommand.deserializeBinaryFromReader);
      msg.setReadlog(value);
      break;
    case 13:
      var value = new proto.dash.ReplaceQueuePayloadCommand;
      reader.readMessage(value,proto.dash.ReplaceQueuePayloadCommand.deserializeBinaryFromReader);
      msg.setReplacequeuepayload(value);
      break;
    case 14:
      var value = new proto.dash.SetConfigCommand;
      reader.readMessage(value,proto.dash.SetConfigCommand.deserializeBinaryFromReader);
      msg.setSetconfig(value);
      break;
    case 15:
      var value = new proto.dash.DeleteCommand;
      reader.readMessage(value,proto.dash.DeleteCommand.deserializeBinaryFromReader);
      msg.setDelete(value);
      break;
    case 16:
      var value = new proto.dash.StartDataStreamCommand;
      reader.readMessage(value,proto.dash.StartDataStreamCommand.deserializeBinaryFromReader);
      msg.setStartdata(value);
      break;
    case 17:
      var value = new proto.dash.StopDataStreamCommand;
      reader.readMessage(value,proto.dash.StopDataStreamCommand.deserializeBinaryFromReader);
      msg.setStopdata(value);
      break;
    case 18:
      var value = new proto.dash.PlayCommand;
      reader.readMessage(value,proto.dash.PlayCommand.deserializeBinaryFromReader);
      msg.setPlay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.CommandMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.CommandMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.CommandMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.CommandMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommandtype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDebug();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.dash.DebugCommand.serializeBinaryToWriter
    );
  }
  f = message.getStop();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.dash.StopCommand.serializeBinaryToWriter
    );
  }
  f = message.getQueueitem();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.dash.QueueItemCommand.serializeBinaryToWriter
    );
  }
  f = message.getPausequeue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.dash.PauseQueueCommand.serializeBinaryToWriter
    );
  }
  f = message.getResumequeue();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.dash.ResumeQueueCommand.serializeBinaryToWriter
    );
  }
  f = message.getSearch();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.dash.SearchCommand.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.dash.GetPayloadCommand.serializeBinaryToWriter
    );
  }
  f = message.getOta();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.dash.OTACommand.serializeBinaryToWriter
    );
  }
  f = message.getListlogs();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.dash.ListLogCommand.serializeBinaryToWriter
    );
  }
  f = message.getReadlog();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.dash.ReadLogCommand.serializeBinaryToWriter
    );
  }
  f = message.getReplacequeuepayload();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.dash.ReplaceQueuePayloadCommand.serializeBinaryToWriter
    );
  }
  f = message.getSetconfig();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.dash.SetConfigCommand.serializeBinaryToWriter
    );
  }
  f = message.getDelete();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.dash.DeleteCommand.serializeBinaryToWriter
    );
  }
  f = message.getStartdata();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.dash.StartDataStreamCommand.serializeBinaryToWriter
    );
  }
  f = message.getStopdata();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.dash.StopDataStreamCommand.serializeBinaryToWriter
    );
  }
  f = message.getPlay();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.dash.PlayCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommandType CommandType = 1;
 * @return {!proto.dash.CommandType}
 */
proto.dash.CommandMessage.prototype.getCommandtype = function() {
  return /** @type {!proto.dash.CommandType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.dash.CommandType} value
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.setCommandtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ID = 2;
 * @return {string}
 */
proto.dash.CommandMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional DebugCommand Debug = 3;
 * @return {?proto.dash.DebugCommand}
 */
proto.dash.CommandMessage.prototype.getDebug = function() {
  return /** @type{?proto.dash.DebugCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.DebugCommand, 3));
};


/**
 * @param {?proto.dash.DebugCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setDebug = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearDebug = function() {
  return this.setDebug(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional StopCommand Stop = 4;
 * @return {?proto.dash.StopCommand}
 */
proto.dash.CommandMessage.prototype.getStop = function() {
  return /** @type{?proto.dash.StopCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.StopCommand, 4));
};


/**
 * @param {?proto.dash.StopCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setStop = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearStop = function() {
  return this.setStop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasStop = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QueueItemCommand QueueItem = 5;
 * @return {?proto.dash.QueueItemCommand}
 */
proto.dash.CommandMessage.prototype.getQueueitem = function() {
  return /** @type{?proto.dash.QueueItemCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.QueueItemCommand, 5));
};


/**
 * @param {?proto.dash.QueueItemCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setQueueitem = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearQueueitem = function() {
  return this.setQueueitem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasQueueitem = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PauseQueueCommand PauseQueue = 6;
 * @return {?proto.dash.PauseQueueCommand}
 */
proto.dash.CommandMessage.prototype.getPausequeue = function() {
  return /** @type{?proto.dash.PauseQueueCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.PauseQueueCommand, 6));
};


/**
 * @param {?proto.dash.PauseQueueCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setPausequeue = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearPausequeue = function() {
  return this.setPausequeue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasPausequeue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ResumeQueueCommand ResumeQueue = 7;
 * @return {?proto.dash.ResumeQueueCommand}
 */
proto.dash.CommandMessage.prototype.getResumequeue = function() {
  return /** @type{?proto.dash.ResumeQueueCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.ResumeQueueCommand, 7));
};


/**
 * @param {?proto.dash.ResumeQueueCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setResumequeue = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearResumequeue = function() {
  return this.setResumequeue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasResumequeue = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SearchCommand Search = 8;
 * @return {?proto.dash.SearchCommand}
 */
proto.dash.CommandMessage.prototype.getSearch = function() {
  return /** @type{?proto.dash.SearchCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.SearchCommand, 8));
};


/**
 * @param {?proto.dash.SearchCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setSearch = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearSearch = function() {
  return this.setSearch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasSearch = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional GetPayloadCommand Payload = 9;
 * @return {?proto.dash.GetPayloadCommand}
 */
proto.dash.CommandMessage.prototype.getPayload = function() {
  return /** @type{?proto.dash.GetPayloadCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.GetPayloadCommand, 9));
};


/**
 * @param {?proto.dash.GetPayloadCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional OTACommand OTA = 10;
 * @return {?proto.dash.OTACommand}
 */
proto.dash.CommandMessage.prototype.getOta = function() {
  return /** @type{?proto.dash.OTACommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.OTACommand, 10));
};


/**
 * @param {?proto.dash.OTACommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setOta = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearOta = function() {
  return this.setOta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasOta = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ListLogCommand ListLogs = 11;
 * @return {?proto.dash.ListLogCommand}
 */
proto.dash.CommandMessage.prototype.getListlogs = function() {
  return /** @type{?proto.dash.ListLogCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.ListLogCommand, 11));
};


/**
 * @param {?proto.dash.ListLogCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setListlogs = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearListlogs = function() {
  return this.setListlogs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasListlogs = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ReadLogCommand ReadLog = 12;
 * @return {?proto.dash.ReadLogCommand}
 */
proto.dash.CommandMessage.prototype.getReadlog = function() {
  return /** @type{?proto.dash.ReadLogCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.ReadLogCommand, 12));
};


/**
 * @param {?proto.dash.ReadLogCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setReadlog = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearReadlog = function() {
  return this.setReadlog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasReadlog = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ReplaceQueuePayloadCommand ReplaceQueuePayload = 13;
 * @return {?proto.dash.ReplaceQueuePayloadCommand}
 */
proto.dash.CommandMessage.prototype.getReplacequeuepayload = function() {
  return /** @type{?proto.dash.ReplaceQueuePayloadCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.ReplaceQueuePayloadCommand, 13));
};


/**
 * @param {?proto.dash.ReplaceQueuePayloadCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setReplacequeuepayload = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearReplacequeuepayload = function() {
  return this.setReplacequeuepayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasReplacequeuepayload = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional SetConfigCommand SetConfig = 14;
 * @return {?proto.dash.SetConfigCommand}
 */
proto.dash.CommandMessage.prototype.getSetconfig = function() {
  return /** @type{?proto.dash.SetConfigCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.SetConfigCommand, 14));
};


/**
 * @param {?proto.dash.SetConfigCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setSetconfig = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearSetconfig = function() {
  return this.setSetconfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasSetconfig = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional DeleteCommand Delete = 15;
 * @return {?proto.dash.DeleteCommand}
 */
proto.dash.CommandMessage.prototype.getDelete = function() {
  return /** @type{?proto.dash.DeleteCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.DeleteCommand, 15));
};


/**
 * @param {?proto.dash.DeleteCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setDelete = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearDelete = function() {
  return this.setDelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasDelete = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional StartDataStreamCommand StartData = 16;
 * @return {?proto.dash.StartDataStreamCommand}
 */
proto.dash.CommandMessage.prototype.getStartdata = function() {
  return /** @type{?proto.dash.StartDataStreamCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.StartDataStreamCommand, 16));
};


/**
 * @param {?proto.dash.StartDataStreamCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setStartdata = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearStartdata = function() {
  return this.setStartdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasStartdata = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional StopDataStreamCommand StopData = 17;
 * @return {?proto.dash.StopDataStreamCommand}
 */
proto.dash.CommandMessage.prototype.getStopdata = function() {
  return /** @type{?proto.dash.StopDataStreamCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.StopDataStreamCommand, 17));
};


/**
 * @param {?proto.dash.StopDataStreamCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setStopdata = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearStopdata = function() {
  return this.setStopdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasStopdata = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional PlayCommand Play = 18;
 * @return {?proto.dash.PlayCommand}
 */
proto.dash.CommandMessage.prototype.getPlay = function() {
  return /** @type{?proto.dash.PlayCommand} */ (
    jspb.Message.getWrapperField(this, proto.dash.PlayCommand, 18));
};


/**
 * @param {?proto.dash.PlayCommand|undefined} value
 * @return {!proto.dash.CommandMessage} returns this
*/
proto.dash.CommandMessage.prototype.setPlay = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.CommandMessage} returns this
 */
proto.dash.CommandMessage.prototype.clearPlay = function() {
  return this.setPlay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.CommandMessage.prototype.hasPlay = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.QueuesMessage.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.QueuesMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.QueuesMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.QueuesMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueuesMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    queuesList: jspb.Message.toObjectList(msg.getQueuesList(),
    proto.dash.Strings.toObject, includeInstance),
    pausedMap: (f = msg.getPausedMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.QueuesMessage}
 */
proto.dash.QueuesMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.QueuesMessage;
  return proto.dash.QueuesMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.QueuesMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.QueuesMessage}
 */
proto.dash.QueuesMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = new proto.dash.Strings;
      reader.readMessage(value,proto.dash.Strings.deserializeBinaryFromReader);
      msg.addQueues(value);
      break;
    case 4:
      var value = msg.getPausedMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBool, null, "", false);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.QueuesMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.QueuesMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.QueuesMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueuesMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQueuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.dash.Strings.serializeBinaryToWriter
    );
  }
  f = message.getPausedMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBool);
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.QueuesMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueuesMessage} returns this
 */
proto.dash.QueuesMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.QueuesMessage.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueuesMessage} returns this
 */
proto.dash.QueuesMessage.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Strings Queues = 3;
 * @return {!Array<!proto.dash.Strings>}
 */
proto.dash.QueuesMessage.prototype.getQueuesList = function() {
  return /** @type{!Array<!proto.dash.Strings>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dash.Strings, 3));
};


/**
 * @param {!Array<!proto.dash.Strings>} value
 * @return {!proto.dash.QueuesMessage} returns this
*/
proto.dash.QueuesMessage.prototype.setQueuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.dash.Strings=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.Strings}
 */
proto.dash.QueuesMessage.prototype.addQueues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dash.Strings, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.QueuesMessage} returns this
 */
proto.dash.QueuesMessage.prototype.clearQueuesList = function() {
  return this.setQueuesList([]);
};


/**
 * map<string, bool> Paused = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,boolean>}
 */
proto.dash.QueuesMessage.prototype.getPausedMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,boolean>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.dash.QueuesMessage} returns this
 */
proto.dash.QueuesMessage.prototype.clearPausedMap = function() {
  this.getPausedMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.QueueItemMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.QueueItemMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.QueueItemMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueItemMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.QueueItemMessage}
 */
proto.dash.QueueItemMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.QueueItemMessage;
  return proto.dash.QueueItemMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.QueueItemMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.QueueItemMessage}
 */
proto.dash.QueueItemMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.QueueItemMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.QueueItemMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.QueueItemMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueItemMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.QueueItemMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemMessage} returns this
 */
proto.dash.QueueItemMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Queue = 2;
 * @return {string}
 */
proto.dash.QueueItemMessage.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemMessage} returns this
 */
proto.dash.QueueItemMessage.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ID = 3;
 * @return {string}
 */
proto.dash.QueueItemMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemMessage} returns this
 */
proto.dash.QueueItemMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.QueueContentMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.QueueContentMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.QueueContentMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueContentMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    payload: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.QueueContentMessage}
 */
proto.dash.QueueContentMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.QueueContentMessage;
  return proto.dash.QueueContentMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.QueueContentMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.QueueContentMessage}
 */
proto.dash.QueueContentMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.QueueContentMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.QueueContentMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.QueueContentMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueContentMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPayload();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.QueueContentMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueContentMessage} returns this
 */
proto.dash.QueueContentMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Queue = 2;
 * @return {string}
 */
proto.dash.QueueContentMessage.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueContentMessage} returns this
 */
proto.dash.QueueContentMessage.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ID = 3;
 * @return {string}
 */
proto.dash.QueueContentMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueContentMessage} returns this
 */
proto.dash.QueueContentMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Payload = 4;
 * @return {string}
 */
proto.dash.QueueContentMessage.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueContentMessage} returns this
 */
proto.dash.QueueContentMessage.prototype.setPayload = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.SearchContentMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.SearchContentMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.SearchContentMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SearchContentMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payload: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.SearchContentMessage}
 */
proto.dash.SearchContentMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.SearchContentMessage;
  return proto.dash.SearchContentMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.SearchContentMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.SearchContentMessage}
 */
proto.dash.SearchContentMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.SearchContentMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.SearchContentMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.SearchContentMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SearchContentMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayload();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.SearchContentMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchContentMessage} returns this
 */
proto.dash.SearchContentMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Payload = 2;
 * @return {string}
 */
proto.dash.SearchContentMessage.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchContentMessage} returns this
 */
proto.dash.SearchContentMessage.prototype.setPayload = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.LogResponseMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.LogResponseMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.LogResponseMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.LogResponseMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    payload: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.LogResponseMessage}
 */
proto.dash.LogResponseMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.LogResponseMessage;
  return proto.dash.LogResponseMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.LogResponseMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.LogResponseMessage}
 */
proto.dash.LogResponseMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.LogResponseMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.LogResponseMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.LogResponseMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.LogResponseMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPayload();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.LogResponseMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.LogResponseMessage} returns this
 */
proto.dash.LogResponseMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Payload = 2;
 * @return {string}
 */
proto.dash.LogResponseMessage.prototype.getPayload = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.LogResponseMessage} returns this
 */
proto.dash.LogResponseMessage.prototype.setPayload = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.DataMessage.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.DataMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.DataMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.DataMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DataMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    app: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    payload: (f = msg.getPayload()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 4, ""),
    client: jspb.Message.getFieldWithDefault(msg, 5, ""),
    successrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    stepindex: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    typeinfo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    steplistList: jspb.Message.toObjectList(msg.getSteplistList(),
    proto.dash.StepMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.DataMessage}
 */
proto.dash.DataMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.DataMessage;
  return proto.dash.DataMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.DataMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.DataMessage}
 */
proto.dash.DataMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClient(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSuccessrate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepindex(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeinfo(value);
      break;
    case 10:
      var value = new proto.dash.StepMessage;
      reader.readMessage(value,proto.dash.StepMessage.deserializeBinaryFromReader);
      msg.addSteplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.DataMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.DataMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.DataMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DataMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSuccessrate();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getStepindex();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTypeinfo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSteplistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.dash.StepMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string App = 1;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Any Payload = 3;
 * @return {?proto.google.protobuf.Any}
 */
proto.dash.DataMessage.prototype.getPayload = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 3));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.dash.DataMessage} returns this
*/
proto.dash.DataMessage.prototype.setPayload = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.clearPayload = function() {
  return this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.DataMessage.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string ID = 4;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Client = 5;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setClient = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional float SuccessRate = 6;
 * @return {number}
 */
proto.dash.DataMessage.prototype.getSuccessrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setSuccessrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 StepIndex = 7;
 * @return {number}
 */
proto.dash.DataMessage.prototype.getStepindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setStepindex = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string Status = 8;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string TypeInfo = 9;
 * @return {string}
 */
proto.dash.DataMessage.prototype.getTypeinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.setTypeinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated StepMessage StepList = 10;
 * @return {!Array<!proto.dash.StepMessage>}
 */
proto.dash.DataMessage.prototype.getSteplistList = function() {
  return /** @type{!Array<!proto.dash.StepMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dash.StepMessage, 10));
};


/**
 * @param {!Array<!proto.dash.StepMessage>} value
 * @return {!proto.dash.DataMessage} returns this
*/
proto.dash.DataMessage.prototype.setSteplistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.dash.StepMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.StepMessage}
 */
proto.dash.DataMessage.prototype.addSteplist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.dash.StepMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.DataMessage} returns this
 */
proto.dash.DataMessage.prototype.clearSteplistList = function() {
  return this.setSteplistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.AlertMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.AlertMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.AlertMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.AlertMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    app: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    version: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    slackchannel: jspb.Message.getFieldWithDefault(msg, 6, ""),
    slackapikey: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    alerttype: jspb.Message.getFieldWithDefault(msg, 9, ""),
    alert: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.AlertMessage}
 */
proto.dash.AlertMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.AlertMessage;
  return proto.dash.AlertMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.AlertMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.AlertMessage}
 */
proto.dash.AlertMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlackchannel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlackapikey(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlerttype(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.AlertMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.AlertMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.AlertMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.AlertMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSlackchannel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSlackapikey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAlerttype();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAlert();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string App = 1;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Version = 4;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Email = 5;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string SlackChannel = 6;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getSlackchannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setSlackchannel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string SlackApikey = 7;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getSlackapikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setSlackapikey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Status = 8;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AlertType = 9;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getAlerttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setAlerttype = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Alert = 10;
 * @return {string}
 */
proto.dash.AlertMessage.prototype.getAlert = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.AlertMessage} returns this
 */
proto.dash.AlertMessage.prototype.setAlert = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.UIVersionMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.UIVersionMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.UIVersionMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.UIVersionMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: jspb.Message.getFieldWithDefault(msg, 1, ""),
    date: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.UIVersionMessage}
 */
proto.dash.UIVersionMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.UIVersionMessage;
  return proto.dash.UIVersionMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.UIVersionMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.UIVersionMessage}
 */
proto.dash.UIVersionMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.UIVersionMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.UIVersionMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.UIVersionMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.UIVersionMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDate();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string Version = 1;
 * @return {string}
 */
proto.dash.UIVersionMessage.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.UIVersionMessage} returns this
 */
proto.dash.UIVersionMessage.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 Date = 2;
 * @return {number}
 */
proto.dash.UIVersionMessage.prototype.getDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.UIVersionMessage} returns this
 */
proto.dash.UIVersionMessage.prototype.setDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.ResponseMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.ResponseMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.ResponseMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ResponseMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    response: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: (f = msg.getData()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.ResponseMessage}
 */
proto.dash.ResponseMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.ResponseMessage;
  return proto.dash.ResponseMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.ResponseMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.ResponseMessage}
 */
proto.dash.ResponseMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponse(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.ResponseMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.ResponseMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.ResponseMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ResponseMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Response = 1;
 * @return {string}
 */
proto.dash.ResponseMessage.prototype.getResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ResponseMessage} returns this
 */
proto.dash.ResponseMessage.prototype.setResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Any Data = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.dash.ResponseMessage.prototype.getData = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.dash.ResponseMessage} returns this
*/
proto.dash.ResponseMessage.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.ResponseMessage} returns this
 */
proto.dash.ResponseMessage.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.ResponseMessage.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.StatsMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.StatsMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.StatsMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StatsMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    memoryusage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    diskavailable: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.StatsMessage}
 */
proto.dash.StatsMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.StatsMessage;
  return proto.dash.StatsMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.StatsMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.StatsMessage}
 */
proto.dash.StatsMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMemoryusage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setDiskavailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.StatsMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.StatsMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.StatsMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StatsMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMemoryusage();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getDiskavailable();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.StatsMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StatsMessage} returns this
 */
proto.dash.StatsMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 MemoryUsage = 2;
 * @return {number}
 */
proto.dash.StatsMessage.prototype.getMemoryusage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.StatsMessage} returns this
 */
proto.dash.StatsMessage.prototype.setMemoryusage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 DiskAvailable = 3;
 * @return {number}
 */
proto.dash.StatsMessage.prototype.getDiskavailable = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.StatsMessage} returns this
 */
proto.dash.StatsMessage.prototype.setDiskavailable = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.DebugTimeOutMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.DebugTimeOutMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.DebugTimeOutMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DebugTimeOutMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.DebugTimeOutMessage}
 */
proto.dash.DebugTimeOutMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.DebugTimeOutMessage;
  return proto.dash.DebugTimeOutMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.DebugTimeOutMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.DebugTimeOutMessage}
 */
proto.dash.DebugTimeOutMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.DebugTimeOutMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.DebugTimeOutMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.DebugTimeOutMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DebugTimeOutMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Hash = 1;
 * @return {string}
 */
proto.dash.DebugTimeOutMessage.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DebugTimeOutMessage} returns this
 */
proto.dash.DebugTimeOutMessage.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ErrorMessage = 2;
 * @return {string}
 */
proto.dash.DebugTimeOutMessage.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DebugTimeOutMessage} returns this
 */
proto.dash.DebugTimeOutMessage.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.StepMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.StepMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.StepMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StepMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    data: (f = msg.getData()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.StepMessage}
 */
proto.dash.StepMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.StepMessage;
  return proto.dash.StepMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.StepMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.StepMessage}
 */
proto.dash.StepMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.StepMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.StepMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.StepMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StepMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Type = 1;
 * @return {string}
 */
proto.dash.StepMessage.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StepMessage} returns this
 */
proto.dash.StepMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Label = 2;
 * @return {string}
 */
proto.dash.StepMessage.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StepMessage} returns this
 */
proto.dash.StepMessage.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Any Data = 4;
 * @return {?proto.google.protobuf.Any}
 */
proto.dash.StepMessage.prototype.getData = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 4));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.dash.StepMessage} returns this
*/
proto.dash.StepMessage.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dash.StepMessage} returns this
 */
proto.dash.StepMessage.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dash.StepMessage.prototype.hasData = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.MessageStep.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.MessageStep.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.MessageStep} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.MessageStep.toObject = function(includeInstance, msg) {
  var f, obj = {
    app: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    client: jspb.Message.getFieldWithDefault(msg, 3, ""),
    id: jspb.Message.getFieldWithDefault(msg, 4, ""),
    stepno: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.MessageStep}
 */
proto.dash.MessageStep.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.MessageStep;
  return proto.dash.MessageStep.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.MessageStep} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.MessageStep}
 */
proto.dash.MessageStep.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClient(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStepno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.MessageStep.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.MessageStep.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.MessageStep} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.MessageStep.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStepno();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string App = 1;
 * @return {string}
 */
proto.dash.MessageStep.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageStep} returns this
 */
proto.dash.MessageStep.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.MessageStep.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageStep} returns this
 */
proto.dash.MessageStep.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Client = 3;
 * @return {string}
 */
proto.dash.MessageStep.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageStep} returns this
 */
proto.dash.MessageStep.prototype.setClient = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ID = 4;
 * @return {string}
 */
proto.dash.MessageStep.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageStep} returns this
 */
proto.dash.MessageStep.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 StepNo = 5;
 * @return {number}
 */
proto.dash.MessageStep.prototype.getStepno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.MessageStep} returns this
 */
proto.dash.MessageStep.prototype.setStepno = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.GetEventsMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.GetEventsMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.GetEventsMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.GetEventsMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventtype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    createdat: jspb.Message.getFieldWithDefault(msg, 2, ""),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reference: jspb.Message.getFieldWithDefault(msg, 4, ""),
    message: jspb.Message.getFieldWithDefault(msg, 5, ""),
    error: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 7, ""),
    step: jspb.Message.getFieldWithDefault(msg, 8, ""),
    appid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    successrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.GetEventsMessage}
 */
proto.dash.GetEventsMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.GetEventsMessage;
  return proto.dash.GetEventsMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.GetEventsMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.GetEventsMessage}
 */
proto.dash.GetEventsMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.dash.EventType} */ (reader.readEnum());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReference(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStep(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSuccessrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.GetEventsMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.GetEventsMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.GetEventsMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.GetEventsMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventtype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCreatedat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReference();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStep();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSuccessrate();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
};


/**
 * optional EventType EventType = 1;
 * @return {!proto.dash.EventType}
 */
proto.dash.GetEventsMessage.prototype.getEventtype = function() {
  return /** @type {!proto.dash.EventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.dash.EventType} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string CreatedAt = 2;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Label = 3;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Reference = 4;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setReference = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Message = 5;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Error = 6;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Interface = 7;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Step = 8;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getStep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setStep = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AppID = 9;
 * @return {string}
 */
proto.dash.GetEventsMessage.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional float SuccessRate = 10;
 * @return {number}
 */
proto.dash.GetEventsMessage.prototype.getSuccessrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.dash.GetEventsMessage} returns this
 */
proto.dash.GetEventsMessage.prototype.setSuccessrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.MessageRef.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.MessageRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.MessageRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.MessageRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    app: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reference: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userreference: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.MessageRef}
 */
proto.dash.MessageRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.MessageRef;
  return proto.dash.MessageRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.MessageRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.MessageRef}
 */
proto.dash.MessageRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReference(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.MessageRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.MessageRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.MessageRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.MessageRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReference();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserreference();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string App = 1;
 * @return {string}
 */
proto.dash.MessageRef.prototype.getApp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageRef} returns this
 */
proto.dash.MessageRef.prototype.setApp = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.MessageRef.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageRef} returns this
 */
proto.dash.MessageRef.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Reference = 3;
 * @return {string}
 */
proto.dash.MessageRef.prototype.getReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageRef} returns this
 */
proto.dash.MessageRef.prototype.setReference = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserReference = 4;
 * @return {string}
 */
proto.dash.MessageRef.prototype.getUserreference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.MessageRef} returns this
 */
proto.dash.MessageRef.prototype.setUserreference = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.InitMessage.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.InitMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.InitMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.InitMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.InitMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    apphash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    steplistList: jspb.Message.toObjectList(msg.getSteplistList(),
    proto.dash.StepMessage.toObject, includeInstance),
    appversion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.InitMessage}
 */
proto.dash.InitMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.InitMessage;
  return proto.dash.InitMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.InitMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.InitMessage}
 */
proto.dash.InitMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApphash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.dash.StepMessage;
      reader.readMessage(value,proto.dash.StepMessage.deserializeBinaryFromReader);
      msg.addSteplist(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.InitMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.InitMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.InitMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.InitMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApphash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSteplistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.dash.StepMessage.serializeBinaryToWriter
    );
  }
  f = message.getAppversion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string AppHash = 1;
 * @return {string}
 */
proto.dash.InitMessage.prototype.getApphash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.InitMessage} returns this
 */
proto.dash.InitMessage.prototype.setApphash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Message = 2;
 * @return {string}
 */
proto.dash.InitMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.InitMessage} returns this
 */
proto.dash.InitMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated StepMessage StepList = 3;
 * @return {!Array<!proto.dash.StepMessage>}
 */
proto.dash.InitMessage.prototype.getSteplistList = function() {
  return /** @type{!Array<!proto.dash.StepMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.dash.StepMessage, 3));
};


/**
 * @param {!Array<!proto.dash.StepMessage>} value
 * @return {!proto.dash.InitMessage} returns this
*/
proto.dash.InitMessage.prototype.setSteplistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.dash.StepMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dash.StepMessage}
 */
proto.dash.InitMessage.prototype.addSteplist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dash.StepMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.InitMessage} returns this
 */
proto.dash.InitMessage.prototype.clearSteplistList = function() {
  return this.setSteplistList([]);
};


/**
 * optional string AppVersion = 4;
 * @return {string}
 */
proto.dash.InitMessage.prototype.getAppversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.InitMessage} returns this
 */
proto.dash.InitMessage.prototype.setAppversion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Timestamp = 5;
 * @return {string}
 */
proto.dash.InitMessage.prototype.getTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.InitMessage} returns this
 */
proto.dash.InitMessage.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.DebugCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.DebugCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.DebugCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DebugCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.DebugCommand}
 */
proto.dash.DebugCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.DebugCommand;
  return proto.dash.DebugCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.DebugCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.DebugCommand}
 */
proto.dash.DebugCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.DebugCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.DebugCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.DebugCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DebugCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.DebugCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DebugCommand} returns this
 */
proto.dash.DebugCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.DebugCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DebugCommand} returns this
 */
proto.dash.DebugCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.DebugCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DebugCommand} returns this
 */
proto.dash.DebugCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.StopCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.StopCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.StopCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StopCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.StopCommand}
 */
proto.dash.StopCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.StopCommand;
  return proto.dash.StopCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.StopCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.StopCommand}
 */
proto.dash.StopCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.StopCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.StopCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.StopCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StopCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.StopCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopCommand} returns this
 */
proto.dash.StopCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.StopCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopCommand} returns this
 */
proto.dash.StopCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.StopCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopCommand} returns this
 */
proto.dash.StopCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.QueueItemCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.QueueItemCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.QueueItemCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueItemCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    id: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.QueueItemCommand}
 */
proto.dash.QueueItemCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.QueueItemCommand;
  return proto.dash.QueueItemCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.QueueItemCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.QueueItemCommand}
 */
proto.dash.QueueItemCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.QueueItemCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.QueueItemCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.QueueItemCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.QueueItemCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.QueueItemCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemCommand} returns this
 */
proto.dash.QueueItemCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.QueueItemCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemCommand} returns this
 */
proto.dash.QueueItemCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Queue = 3;
 * @return {string}
 */
proto.dash.QueueItemCommand.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemCommand} returns this
 */
proto.dash.QueueItemCommand.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ID = 4;
 * @return {string}
 */
proto.dash.QueueItemCommand.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.QueueItemCommand} returns this
 */
proto.dash.QueueItemCommand.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.PauseQueueCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.PauseQueueCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.PauseQueueCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.PauseQueueCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.PauseQueueCommand}
 */
proto.dash.PauseQueueCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.PauseQueueCommand;
  return proto.dash.PauseQueueCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.PauseQueueCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.PauseQueueCommand}
 */
proto.dash.PauseQueueCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.PauseQueueCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.PauseQueueCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.PauseQueueCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.PauseQueueCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.PauseQueueCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PauseQueueCommand} returns this
 */
proto.dash.PauseQueueCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.PauseQueueCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PauseQueueCommand} returns this
 */
proto.dash.PauseQueueCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.PauseQueueCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PauseQueueCommand} returns this
 */
proto.dash.PauseQueueCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Queue = 4;
 * @return {string}
 */
proto.dash.PauseQueueCommand.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PauseQueueCommand} returns this
 */
proto.dash.PauseQueueCommand.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.DeleteCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.DeleteCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.DeleteCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DeleteCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.DeleteCommand}
 */
proto.dash.DeleteCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.DeleteCommand;
  return proto.dash.DeleteCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.DeleteCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.DeleteCommand}
 */
proto.dash.DeleteCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.DeleteCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.DeleteCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.DeleteCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.DeleteCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Key = 3;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Queue = 4;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ItemID = 5;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setItemid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Interface = 6;
 * @return {string}
 */
proto.dash.DeleteCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.DeleteCommand} returns this
 */
proto.dash.DeleteCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.ReplaceQueuePayloadCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.ReplaceQueuePayloadCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ReplaceQueuePayloadCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 6, ""),
    payload: msg.getPayload_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.ReplaceQueuePayloadCommand}
 */
proto.dash.ReplaceQueuePayloadCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.ReplaceQueuePayloadCommand;
  return proto.dash.ReplaceQueuePayloadCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.ReplaceQueuePayloadCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.ReplaceQueuePayloadCommand}
 */
proto.dash.ReplaceQueuePayloadCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.ReplaceQueuePayloadCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.ReplaceQueuePayloadCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ReplaceQueuePayloadCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Key = 3;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Queue = 4;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ItemID = 5;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setItemid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Interface = 6;
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bytes Payload = 7;
 * @return {!(string|Uint8Array)}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getPayload = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes Payload = 7;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPayload()));
};


/**
 * optional bytes Payload = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.getPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dash.ReplaceQueuePayloadCommand} returns this
 */
proto.dash.ReplaceQueuePayloadCommand.prototype.setPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.ResumeQueueCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.ResumeQueueCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.ResumeQueueCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ResumeQueueCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queue: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.ResumeQueueCommand}
 */
proto.dash.ResumeQueueCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.ResumeQueueCommand;
  return proto.dash.ResumeQueueCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.ResumeQueueCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.ResumeQueueCommand}
 */
proto.dash.ResumeQueueCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.ResumeQueueCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.ResumeQueueCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.ResumeQueueCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ResumeQueueCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.ResumeQueueCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ResumeQueueCommand} returns this
 */
proto.dash.ResumeQueueCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.ResumeQueueCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ResumeQueueCommand} returns this
 */
proto.dash.ResumeQueueCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.ResumeQueueCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ResumeQueueCommand} returns this
 */
proto.dash.ResumeQueueCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Queue = 4;
 * @return {string}
 */
proto.dash.ResumeQueueCommand.prototype.getQueue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ResumeQueueCommand} returns this
 */
proto.dash.ResumeQueueCommand.prototype.setQueue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.SearchCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.SearchCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.SearchCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SearchCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, ""),
    query: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.SearchCommand}
 */
proto.dash.SearchCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.SearchCommand;
  return proto.dash.SearchCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.SearchCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.SearchCommand}
 */
proto.dash.SearchCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.SearchCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.SearchCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.SearchCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SearchCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.SearchCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchCommand} returns this
 */
proto.dash.SearchCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.SearchCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchCommand} returns this
 */
proto.dash.SearchCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.SearchCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchCommand} returns this
 */
proto.dash.SearchCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Query = 4;
 * @return {string}
 */
proto.dash.SearchCommand.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SearchCommand} returns this
 */
proto.dash.SearchCommand.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.ListLogCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.ListLogCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.ListLogCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ListLogCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.ListLogCommand}
 */
proto.dash.ListLogCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.ListLogCommand;
  return proto.dash.ListLogCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.ListLogCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.ListLogCommand}
 */
proto.dash.ListLogCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.ListLogCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.ListLogCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.ListLogCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ListLogCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.ListLogCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ListLogCommand} returns this
 */
proto.dash.ListLogCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.ListLogCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ListLogCommand} returns this
 */
proto.dash.ListLogCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.ReadLogCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.ReadLogCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.ReadLogCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ReadLogCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    query: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.ReadLogCommand}
 */
proto.dash.ReadLogCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.ReadLogCommand;
  return proto.dash.ReadLogCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.ReadLogCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.ReadLogCommand}
 */
proto.dash.ReadLogCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.ReadLogCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.ReadLogCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.ReadLogCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.ReadLogCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.ReadLogCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReadLogCommand} returns this
 */
proto.dash.ReadLogCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.ReadLogCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReadLogCommand} returns this
 */
proto.dash.ReadLogCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Query = 3;
 * @return {string}
 */
proto.dash.ReadLogCommand.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.ReadLogCommand} returns this
 */
proto.dash.ReadLogCommand.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.OTACommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.OTACommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.OTACommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.OTACommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    stage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    binary: msg.getBinary_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.OTACommand}
 */
proto.dash.OTACommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.OTACommand;
  return proto.dash.OTACommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.OTACommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.OTACommand}
 */
proto.dash.OTACommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {!proto.dash.Stage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBinary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.OTACommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.OTACommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.OTACommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.OTACommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBinary_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.OTACommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.OTACommand} returns this
 */
proto.dash.OTACommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Stage Stage = 2;
 * @return {!proto.dash.Stage}
 */
proto.dash.OTACommand.prototype.getStage = function() {
  return /** @type {!proto.dash.Stage} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.dash.Stage} value
 * @return {!proto.dash.OTACommand} returns this
 */
proto.dash.OTACommand.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bytes Binary = 3;
 * @return {!(string|Uint8Array)}
 */
proto.dash.OTACommand.prototype.getBinary = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes Binary = 3;
 * This is a type-conversion wrapper around `getBinary()`
 * @return {string}
 */
proto.dash.OTACommand.prototype.getBinary_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBinary()));
};


/**
 * optional bytes Binary = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBinary()`
 * @return {!Uint8Array}
 */
proto.dash.OTACommand.prototype.getBinary_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBinary()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dash.OTACommand} returns this
 */
proto.dash.OTACommand.prototype.setBinary = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.GetPayloadCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.GetPayloadCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.GetPayloadCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.GetPayloadCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.GetPayloadCommand}
 */
proto.dash.GetPayloadCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.GetPayloadCommand;
  return proto.dash.GetPayloadCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.GetPayloadCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.GetPayloadCommand}
 */
proto.dash.GetPayloadCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.GetPayloadCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.GetPayloadCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.GetPayloadCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.GetPayloadCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.GetPayloadCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetPayloadCommand} returns this
 */
proto.dash.GetPayloadCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.GetPayloadCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetPayloadCommand} returns this
 */
proto.dash.GetPayloadCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Key = 3;
 * @return {string}
 */
proto.dash.GetPayloadCommand.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.GetPayloadCommand} returns this
 */
proto.dash.GetPayloadCommand.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.SetConfigCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.SetConfigCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.SetConfigCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SetConfigCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    interfaceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    config: msg.getConfig_asB64(),
    env: msg.getEnv_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.SetConfigCommand}
 */
proto.dash.SetConfigCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.SetConfigCommand;
  return proto.dash.SetConfigCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.SetConfigCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.SetConfigCommand}
 */
proto.dash.SetConfigCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterfaceid(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setConfig(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEnv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.SetConfigCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.SetConfigCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.SetConfigCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.SetConfigCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterfaceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConfig_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getEnv_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.SetConfigCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SetConfigCommand} returns this
 */
proto.dash.SetConfigCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string InterfaceID = 2;
 * @return {string}
 */
proto.dash.SetConfigCommand.prototype.getInterfaceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.SetConfigCommand} returns this
 */
proto.dash.SetConfigCommand.prototype.setInterfaceid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes Config = 3;
 * @return {!(string|Uint8Array)}
 */
proto.dash.SetConfigCommand.prototype.getConfig = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes Config = 3;
 * This is a type-conversion wrapper around `getConfig()`
 * @return {string}
 */
proto.dash.SetConfigCommand.prototype.getConfig_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getConfig()));
};


/**
 * optional bytes Config = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getConfig()`
 * @return {!Uint8Array}
 */
proto.dash.SetConfigCommand.prototype.getConfig_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getConfig()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dash.SetConfigCommand} returns this
 */
proto.dash.SetConfigCommand.prototype.setConfig = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional bytes Env = 4;
 * @return {!(string|Uint8Array)}
 */
proto.dash.SetConfigCommand.prototype.getEnv = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes Env = 4;
 * This is a type-conversion wrapper around `getEnv()`
 * @return {string}
 */
proto.dash.SetConfigCommand.prototype.getEnv_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEnv()));
};


/**
 * optional bytes Env = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEnv()`
 * @return {!Uint8Array}
 */
proto.dash.SetConfigCommand.prototype.getEnv_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEnv()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.dash.SetConfigCommand} returns this
 */
proto.dash.SetConfigCommand.prototype.setEnv = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.StartDataStreamCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.StartDataStreamCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.StartDataStreamCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StartDataStreamCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    client: jspb.Message.getFieldWithDefault(msg, 3, ""),
    id: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.StartDataStreamCommand}
 */
proto.dash.StartDataStreamCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.StartDataStreamCommand;
  return proto.dash.StartDataStreamCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.StartDataStreamCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.StartDataStreamCommand}
 */
proto.dash.StartDataStreamCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClient(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.StartDataStreamCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.StartDataStreamCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.StartDataStreamCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StartDataStreamCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.StartDataStreamCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StartDataStreamCommand} returns this
 */
proto.dash.StartDataStreamCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.StartDataStreamCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StartDataStreamCommand} returns this
 */
proto.dash.StartDataStreamCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Client = 3;
 * @return {string}
 */
proto.dash.StartDataStreamCommand.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StartDataStreamCommand} returns this
 */
proto.dash.StartDataStreamCommand.prototype.setClient = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 ID = 4;
 * @return {number}
 */
proto.dash.StartDataStreamCommand.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.StartDataStreamCommand} returns this
 */
proto.dash.StartDataStreamCommand.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.StopDataStreamCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.StopDataStreamCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.StopDataStreamCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StopDataStreamCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
    client: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.StopDataStreamCommand}
 */
proto.dash.StopDataStreamCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.StopDataStreamCommand;
  return proto.dash.StopDataStreamCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.StopDataStreamCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.StopDataStreamCommand}
 */
proto.dash.StopDataStreamCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.StopDataStreamCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.StopDataStreamCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.StopDataStreamCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.StopDataStreamCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClient();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.StopDataStreamCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopDataStreamCommand} returns this
 */
proto.dash.StopDataStreamCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Interface = 2;
 * @return {string}
 */
proto.dash.StopDataStreamCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopDataStreamCommand} returns this
 */
proto.dash.StopDataStreamCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Client = 3;
 * @return {string}
 */
proto.dash.StopDataStreamCommand.prototype.getClient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.StopDataStreamCommand} returns this
 */
proto.dash.StopDataStreamCommand.prototype.setClient = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.PlayCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.PlayCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.PlayCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.PlayCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pinned: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.PlayCommand}
 */
proto.dash.PlayCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.PlayCommand;
  return proto.dash.PlayCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.PlayCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.PlayCommand}
 */
proto.dash.PlayCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPinned(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.PlayCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.PlayCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.PlayCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.PlayCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPinned();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string AppID = 1;
 * @return {string}
 */
proto.dash.PlayCommand.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PlayCommand} returns this
 */
proto.dash.PlayCommand.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Hash = 2;
 * @return {string}
 */
proto.dash.PlayCommand.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PlayCommand} returns this
 */
proto.dash.PlayCommand.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Interface = 3;
 * @return {string}
 */
proto.dash.PlayCommand.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.PlayCommand} returns this
 */
proto.dash.PlayCommand.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool Pinned = 4;
 * @return {boolean}
 */
proto.dash.PlayCommand.prototype.getPinned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dash.PlayCommand} returns this
 */
proto.dash.PlayCommand.prototype.setPinned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.dash.Strings.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.Strings.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.Strings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.Strings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.Strings.toObject = function(includeInstance, msg) {
  var f, obj = {
    valueList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.Strings}
 */
proto.dash.Strings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.Strings;
  return proto.dash.Strings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.Strings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.Strings}
 */
proto.dash.Strings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.Strings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.Strings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.Strings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.Strings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValueList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string value = 1;
 * @return {!Array<string>}
 */
proto.dash.Strings.prototype.getValueList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.dash.Strings} returns this
 */
proto.dash.Strings.prototype.setValueList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dash.Strings} returns this
 */
proto.dash.Strings.prototype.addValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dash.Strings} returns this
 */
proto.dash.Strings.prototype.clearValueList = function() {
  return this.setValueList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.EventMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.EventMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.EventMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.EventMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventtype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    createdat: jspb.Message.getFieldWithDefault(msg, 2, ""),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reference: jspb.Message.getFieldWithDefault(msg, 4, ""),
    message: jspb.Message.getFieldWithDefault(msg, 5, ""),
    error: jspb.Message.getFieldWithDefault(msg, 6, ""),
    pb_interface: jspb.Message.getFieldWithDefault(msg, 7, ""),
    step: jspb.Message.getFieldWithDefault(msg, 8, 0),
    appid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    successrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.EventMessage}
 */
proto.dash.EventMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.EventMessage;
  return proto.dash.EventMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.EventMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.EventMessage}
 */
proto.dash.EventMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.dash.EventType} */ (reader.readEnum());
      msg.setEventtype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReference(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStep(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSuccessrate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.EventMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.EventMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.EventMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.EventMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventtype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCreatedat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReference();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStep();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSuccessrate();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
};


/**
 * optional EventType EventType = 1;
 * @return {!proto.dash.EventType}
 */
proto.dash.EventMessage.prototype.getEventtype = function() {
  return /** @type {!proto.dash.EventType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.dash.EventType} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string CreatedAt = 2;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Label = 3;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Reference = 4;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getReference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setReference = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Message = 5;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Error = 6;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Interface = 7;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 Step = 8;
 * @return {number}
 */
proto.dash.EventMessage.prototype.getStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setStep = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string AppID = 9;
 * @return {string}
 */
proto.dash.EventMessage.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional float SuccessRate = 10;
 * @return {number}
 */
proto.dash.EventMessage.prototype.getSuccessrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.dash.EventMessage} returns this
 */
proto.dash.EventMessage.prototype.setSuccessrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dash.OTAResponseMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.dash.OTAResponseMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dash.OTAResponseMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.OTAResponseMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    errormessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dash.OTAResponseMessage}
 */
proto.dash.OTAResponseMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dash.OTAResponseMessage;
  return proto.dash.OTAResponseMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dash.OTAResponseMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dash.OTAResponseMessage}
 */
proto.dash.OTAResponseMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrormessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dash.OTAResponseMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dash.OTAResponseMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dash.OTAResponseMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dash.OTAResponseMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getErrormessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool Success = 1;
 * @return {boolean}
 */
proto.dash.OTAResponseMessage.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dash.OTAResponseMessage} returns this
 */
proto.dash.OTAResponseMessage.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string ErrorMessage = 2;
 * @return {string}
 */
proto.dash.OTAResponseMessage.prototype.getErrormessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dash.OTAResponseMessage} returns this
 */
proto.dash.OTAResponseMessage.prototype.setErrormessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.dash.MessageType = {
  TYPEINIT: 0,
  TYPEEVENTS: 1,
  TYPEQUEUES: 3,
  TYPEQUEUECONTENT: 4,
  TYPESEARCHRESULT: 5,
  TYPERESPONSE: 6,
  TYPEOTARESPONSE: 7,
  TYPELOGRESPONSE: 8,
  TYPEBROWSER: 9,
  TYPESENDDATA: 10,
  TYPESTATS: 11,
  TYPEDEBUGTIMEOUT: 12,
  TYPELISTEVENTS: 13,
  TYPEPLAY: 14,
  TYPEALERT: 15,
  TYPEVERSION: 16,
  TYPESENDSTEP: 17,
  TYPESENDREF: 18
};

/**
 * @enum {number}
 */
proto.dash.CommandType = {
  TYPEDEBUG: 0,
  TYPESTOP: 1,
  TYPESEARCH: 2,
  TYPEQUEUEITEM: 3,
  TYPEPAUSEQUEUE: 4,
  TYPERESUMEQUEUE: 5,
  TYPEGETPAYLOAD: 6,
  TYPEOTA: 7,
  TYPELISTLOG: 8,
  TYPEREADLOG: 9,
  TYPEREPLACEQUEUEPAYLOAD: 10,
  TYPESETCONFIG: 11,
  TYPEDELETE: 12,
  TYPESTARTDATASTREAM: 13,
  TYPESTOPDATASTREAM: 14,
  TYPEPLAYCOMMAND: 15
};

/**
 * @enum {number}
 */
proto.dash.EventType = {
  TYPEERROR: 0,
  TYPEEVENT: 1
};

/**
 * @enum {number}
 */
proto.dash.Stage = {
  STAGEUPGRADE: 0,
  STAGEKILLCHILD: 1,
  STAGESIGNOFF: 2
};

goog.object.extend(exports, proto);
